<template lang='pug'>
.popupOption.show--smallScreens(@click="$emit('closePopup')")
  ul.popupOption-list
    li.popupOption-item(:class='checkType("all")' @click="filter('all')") 不限
    li.popupOption-item(:class='checkType("today")' @click="filter('today')") 今日
    li.popupOption-item(:class='checkType("this-week")' @click="filter('this-week')") 本週
    li.popupOption-item(:class='checkType("this-month")' @click="filter('this-month')") 本月
    li.popupOption-item(:class='checkType("pickdate")' @click='pickdate') 其他時段
</template>
<script>
export default {
  props: {
    type: String
  },
  methods: {
    filter(type) {
      this.$emit('filter', type)
    },
    checkType(type) {
      if (this.type == type) {
        return 'popupOption-item--active'
      }
      return ''
    },
    pickdate() {
      this.filter('pickdate')
      this.$emit('pickdate')
    }
  }
}
</script>
